/**
 * Responsive Popup Tabs
 * ป๊อปอัปที่ข้างในมีคอนเทนต์ที่แบ่งเนื้อหาด้วยแท็บ
 * @since 2019-04
 *
 */
(function($) {
    var servicePopupInit = function(selector) {
        var $content = $(selector);
        var thumbImages = $content.find('.js-thumb-carousel');
        var thumbGallery = new Swiper(thumbImages, {
                loop: false,
                spaceBetween: 8,
                slidesPerView: 8,
                watchSlidesVisibility: true
        });

        var mainImages = $content.find('.js-room-carousel').get(0);
        var mainGallery = new Swiper(mainImages, {
                loop: true,
                spaceBetween: 10,
                thumbs: {
                        swiper: thumbGallery
                },
                navigation: {
                        prevEl: '.component-slider__button--prev',
                        nextEl: '.component-slider__button--next'
                },
                pagination: {
                        el: '.component-slider__pagination',
                        type: 'fraction'
                }
        });
    }
    
    var popupTabsTypeInit = function () {

        function popupTabsType(el) {
            if (window.innerWidth >= 768) {
                $(el).removeClass('component-popup-tabs--accordion');
                $(el).addClass('component-popup-tabs--tabs');
            } else {
                $(el).removeClass('component-popup-tabs--tabs');
                $(el).addClass('component-popup-tabs--accordion');
            }
        }

        $(document).on('click', '.js-inline-popup-tabs', (event) => {
            event.preventDefault();
            var source = event.currentTarget.hash || event.currentTarget.dataset.target;

            if (!source || !$(source).length) {
                console.error('Target not found or the link has not set target');
                return;
            }

            $.magnificPopup.open({
                type: 'inline',
                items: {
                    src: source
                },
                alignTop: true,
                mainClass: 'component-popup mfp-slide-up',
                removalDelay: 200,
                callbacks: {
                    open: function () {
                        servicePopupInit(this.content);
                    }
                }
            });
        });
    }
    
    console.log('PopupTabsTypeInit');
    
    if (window.PopupTabsTypeInit === undefined) {
        window.PopupTabsTypeInit = popupTabsTypeInit;
    }
    window.PopupTabsTypeInit();

})(jQuery);